import React, { useState } from "react";
import "./patient-register.css";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { updatePatientDetails } from "../../features/patientRegistrationSlice";

const PatientRegister = () => {
  const { register, handleSubmit } = useForm();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = (data) => {
    // console.table(data);
    setIsSubmitted(true);
    dispatch(
      updatePatientDetails({
        firstName: data.patientFirstName,
        lastName: data.patientLastName,
        relation: data.patientRelation,
      })
    );
  };

  const configNextNavLink = () => {
    if (isSubmitted) {
      navigate(`/booking-details`);
    } else {
      navigate(`/patient-registration`);
    }
  };

  return (
    <div className="patient-register">
      <h1>Tell us a bit about your loved one?</h1>
      <form className="user-form__form-block" onSubmit={handleSubmit(onSubmit)}>
        <div className="user-form__input-wrapper">
          <label htmlFor="first name">Patient's First Name *</label>
          <input
            className="user-form__input--text"
            name="first name"
            type="text"
            required
            {...register("patientFirstName")}
          />
        </div>
        <div className="user-form__input-wrapper">
          <label htmlFor="last name">Patient's Last Name *</label>
          <input
            className="user-form__input--text"
            name="last name"
            type="text"
            required
            {...register("patientLastName")}
          />
        </div>
        <label htmlFor="relation-dropdown">
          Your Relationship with the patient *
        </label>
        <div className="user-form__input-wrapper relation-dropdown-wrapper">
          <select id="relation-dropdown" {...register("patientRelation")}>
            <option>Pick your Relationship</option>
            <option>Sibling</option>
            <option>Parent</option>
          </select>
          <span className="relation-dropdown-arrow">
            <UnfoldMoreIcon />
          </span>
        </div>
        <div className="user-form__input-wrapper">
          <input
            className={`${
              isSubmitted
                ? "user-form__input--submit--success"
                : "user-form__input--submit"
            }`}
            value={isSubmitted ? `submitted` : `submit`}
            type="submit"
          />
        </div>
      </form>
      <div className="navigation-btn__group">
        <Button
          color="primary"
          variant="outlined"
          className="navigation__btn"
          endIcon={<NavigateNextIcon />}
          onClick={configNextNavLink}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default PatientRegister;
